import { render, staticRenderFns } from "./ReleaseIntegralCategoryList.vue?vue&type=template&id=32c0a768&scoped=true"
import script from "./ReleaseIntegralCategoryList.vue?vue&type=script&lang=js"
export * from "./ReleaseIntegralCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0a768",
  null
  
)

export default component.exports